import axios from 'axios'
import Cookies from 'js-cookie'
import { apiUrl } from 'lib/@getethos/urls/urls'

import GetSiteUrls from '@/components/global/SiteUrls'

export const validatePhoneTwilio = async (phoneNumber: string) => {
  const { ConfigSiteApiUrl } = GetSiteUrls()
  const url = apiUrl.getValidatePhoneUrl(ConfigSiteApiUrl)

  // Get all cookies
  const allCookies = Cookies.get()
  const cookiesString = Object.entries(allCookies)
    .map(([key, value]) => `${key}=${value}`)
    .join('; ')

  const response = await axios.post(
    url,
    {
      phoneNumber: phoneNumber,
    },
    {
      withCredentials: true,
      headers: {
        Cookie: cookiesString,
        'user-uuid': Cookies.get('USER_UUID'),
      },
    }
  )

  return { response: response.data }
}
